import { SEARCH_TYPE } from '../../constants';

export type SearchType = (typeof SEARCH_TYPE)[keyof typeof SEARCH_TYPE];

export interface SearchImpressionItem {
  id?: string;
  _id?: string;
  title?: string;
  name?: string;
  description?: string;
  snippet?: string;
}

export interface SearchImpressionOptions {
  searchType?: SearchType;
  section?: string;
  sectionType?: string;
  sectionPosition?: number;
  sectionCollapsed?: boolean;
  position?: number;
}

/** The one RESULTS_IMPRESSION payload shape — BigQuery reads every field, so no platform may omit any. */
export function buildSearchImpressionProperties(
  item: SearchImpressionItem,
  resultType: string,
  contextId: string | undefined,
  options: SearchImpressionOptions = {},
) {
  return {
    result_type: resultType,
    result_is_related: options.searchType === SEARCH_TYPE.EXTENDED,
    id: item.id || item._id,
    contextId,
    section: options.section || '',
    section_type: options.sectionType || '',
    section_position: options.sectionPosition || 0,
    section_collapsed: !!options.sectionCollapsed,
    position: options.position || 0,
    title: item.title || item.name || '',
    description: item.description || item.snippet || '',
  };
}
